import React from 'react';
import { Box, Card, CardContent, Button, Typography, Container } from '@mui/material';
import { School as SchoolIcon, Person as ParentIcon, PersonOutline as PersonIcon, AdminPanelSettings as AdminIcon, Business as AgencyIcon } from '@mui/icons-material';

const LoginSelector = () => {
  const handleLoginTypeSelect = (type) => {
    switch (type) {
      case 'school':
        window.location.href = '/school';
        break;
      case 'teacher':
        window.location.href = '/teacher';
        break;
      case 'parent':
        window.location.href = '/parent';
        break;
      case 'agency':
        window.location.href = '/agency';
        break;
      case 'sub_agency':
        window.location.href = '/sub-agency';
        break;
      case 'admin':
        window.location.href = '/admin';
        break;
      default:
        window.location.href = '/';
    }
  };

  return (
    <Container maxWidth="md">
      <Box
        sx={{
          minHeight: '100vh',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          background: 'linear-gradient(160deg, #0f766e 0%, #115e59 45%, #0b3d3a 100%)'
        }}
      >
        <Card sx={{ width: '100%', maxWidth: 800, p: 4 }}>
          <CardContent>
            <Box textAlign="center" mb={4}>
              <Typography variant="h3" fontWeight="bold" gutterBottom>
                Track My Child
              </Typography>
              <Typography variant="h6" color="textSecondary">
                Choose your portal to continue
              </Typography>
            </Box>

            <Box
              sx={{
                display: 'grid',
                gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))',
                gap: 3,
                mt: 4
              }}
            >
              <Card
                sx={{
                  cursor: 'pointer',
                  transition: 'transform 0.2s, box-shadow 0.2s',
                  '&:hover': {
                    transform: 'translateY(-4px)',
                    boxShadow: 4
                  }
                }}
                onClick={() => handleLoginTypeSelect('school')}
              >
                <CardContent sx={{ textAlign: 'center', p: 4 }}>
                  <SchoolIcon sx={{ fontSize: 60, color: 'primary.main', mb: 2 }} />
                  <Typography variant="h5" fontWeight="bold" gutterBottom>
                    School Login
                  </Typography>
                  <Typography variant="body2" color="textSecondary">
                    Access school dashboard to manage students, devices, and payments
                  </Typography>
                  <Button
                    variant="contained"
                    fullWidth
                    sx={{ mt: 3 }}
                    onClick={() => handleLoginTypeSelect('school')}
                  >
                    Login as School
                  </Button>
                </CardContent>
              </Card>

              <Card
                sx={{
                  cursor: 'pointer',
                  transition: 'transform 0.2s, box-shadow 0.2s',
                  '&:hover': {
                    transform: 'translateY(-4px)',
                    boxShadow: 4
                  }
                }}
                onClick={() => handleLoginTypeSelect('teacher')}
              >
                <CardContent sx={{ textAlign: 'center', p: 4 }}>
                  <PersonIcon sx={{ fontSize: 60, color: 'secondary.main', mb: 2 }} />
                  <Typography variant="h5" fontWeight="bold" gutterBottom>
                    Class Teacher
                  </Typography>
                  <Typography variant="body2" color="textSecondary">
                    Assign devices and check student device status on mobile
                  </Typography>
                  <Button
                    variant="contained"
                    color="secondary"
                    fullWidth
                    sx={{ mt: 3 }}
                    onClick={() => handleLoginTypeSelect('teacher')}
                  >
                    Login as Teacher
                  </Button>
                </CardContent>
              </Card>

              <Card
                sx={{
                  cursor: 'pointer',
                  transition: 'transform 0.2s, box-shadow 0.2s',
                  '&:hover': {
                    transform: 'translateY(-4px)',
                    boxShadow: 4
                  }
                }}
                onClick={() => handleLoginTypeSelect('parent')}
              >
                <CardContent sx={{ textAlign: 'center', p: 4 }}>
                  <ParentIcon sx={{ fontSize: 60, color: 'success.main', mb: 2 }} />
                  <Typography variant="h5" fontWeight="bold" gutterBottom>
                    Parent Login
                  </Typography>
                  <Typography variant="body2" color="textSecondary">
                    Track your child's location and view their activity
                  </Typography>
                  <Button
                    variant="contained"
                    color="success"
                    fullWidth
                    sx={{ mt: 3 }}
                    onClick={() => handleLoginTypeSelect('parent')}
                  >
                    Login as Parent
                  </Button>
                </CardContent>
              </Card>

              <Card
                sx={{
                  cursor: 'pointer',
                  transition: 'transform 0.2s, box-shadow 0.2s',
                  '&:hover': {
                    transform: 'translateY(-4px)',
                    boxShadow: 4
                  }
                }}
                onClick={() => handleLoginTypeSelect('agency')}
              >
                <CardContent sx={{ textAlign: 'center', p: 4 }}>
                  <AgencyIcon sx={{ fontSize: 60, color: 'warning.main', mb: 2 }} />
                  <Typography variant="h5" fontWeight="bold" gutterBottom>
                    Agency Login
                  </Typography>
                  <Typography variant="body2" color="textSecondary">
                    Manage multiple schools and coordinate operations
                  </Typography>
                  <Button
                    variant="contained"
                    color="warning"
                    fullWidth
                    sx={{ mt: 3 }}
                    onClick={() => handleLoginTypeSelect('agency')}
                  >
                    Login as Agency
                  </Button>
                </CardContent>
              </Card>

              <Card
                sx={{
                  cursor: 'pointer',
                  transition: 'transform 0.2s, box-shadow 0.2s',
                  '&:hover': {
                    transform: 'translateY(-4px)',
                    boxShadow: 4
                  }
                }}
                onClick={() => handleLoginTypeSelect('sub_agency')}
              >
                <CardContent sx={{ textAlign: 'center', p: 4 }}>
                  <AgencyIcon sx={{ fontSize: 60, color: 'secondary.main', mb: 2 }} />
                  <Typography variant="h5" fontWeight="bold" gutterBottom>
                    Sub-agency Login
                  </Typography>
                  <Typography variant="body2" color="textSecondary">
                    Manage your schools from the commission your agency assigned
                  </Typography>
                  <Button
                    variant="contained"
                    color="secondary"
                    fullWidth
                    sx={{ mt: 3 }}
                    onClick={() => handleLoginTypeSelect('sub_agency')}
                  >
                    Login as Sub-agency
                  </Button>
                </CardContent>
              </Card>

              <Card
                sx={{
                  cursor: 'pointer',
                  transition: 'transform 0.2s, box-shadow 0.2s',
                  '&:hover': {
                    transform: 'translateY(-4px)',
                    boxShadow: 4
                  }
                }}
                onClick={() => handleLoginTypeSelect('admin')}
              >
                <CardContent sx={{ textAlign: 'center', p: 4 }}>
                  <AdminIcon sx={{ fontSize: 60, color: 'error.main', mb: 2 }} />
                  <Typography variant="h5" fontWeight="bold" gutterBottom>
                    Admin Login
                  </Typography>
                  <Typography variant="body2" color="textSecondary">
                    Manage schools, devices, and system administration
                  </Typography>
                  <Button
                    variant="contained"
                    color="error"
                    fullWidth
                    sx={{ mt: 3 }}
                    onClick={() => handleLoginTypeSelect('admin')}
                  >
                    Login as Admin
                  </Button>
                </CardContent>
              </Card>
            </Box>
          </CardContent>
        </Card>
      </Box>
    </Container>
  );
};

export default LoginSelector;